export const track = (event, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    if (event === "page_view") {
      window.fbq("track", "PageView");
    } else if (event === "add_to_cart") {
      window.fbq("track", "AddToCart", {
        content_name: params.items?.[0]?.item_name || "THE SHUTUP T-SHIRT",
        content_type: "product",
        value: params.value ? params.value / 100 : 2000,
        currency: "INR",
      });
    } else if (event === "begin_checkout") {
      window.fbq("track", "InitiateCheckout", {
        content_name: "THE SHUTUP T-SHIRT",
        value: params.value ? params.value / 100 : 2000,
        currency: "INR",
        num_items: params.items?.length || 1,
      });
    } else if (event === "purchase") {
      window.fbq("track", "Purchase", {
        value: params.value ? params.value / 100 : 2000,
        currency: "INR",
        content_type: "product",
      });
    } else if (event === "generate_lead") {
      window.fbq("track", "Lead", {
        content_name: "THE SHUTUP LIST",
      });
    }
  }
};
